export { CheckBoxComponent } from './checkbox.component';
export { L_CheckboxModule } from './checkbox.module';



// WEBPACK FOOTER //
// ./.tmp/checkbox/index.ts